const Config = {

    MAIL_TO: 'mailto:support@gosats.io'

}

export default Config;